import { render, staticRenderFns } from "./manage-purchases.vue?vue&type=template&id=68726aa8&scoped=true"
import script from "./manage-purchases.vue?vue&type=script&lang=js"
export * from "./manage-purchases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68726aa8",
  null
  
)

export default component.exports